module.exports = __webpack_public_path__ + "static/media/cocktail.266cb65c.jpg";